import React, { useEffect, useState } from 'react';
import {
    Box,
    Typography,
    IconButton,
    Collapse,
    Divider,
    Tooltip,
    CircularProgress
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import apiUrl from '../../Config';
import { useNavigate } from 'react-router-dom';

const DisplayFaqs = () => {
    const [faqs, setFaqs] = useState([]);
    const [expandedId, setExpandedId] = useState(null);
    const navigate = useNavigate()

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")

    const fetchFaqData = async () => {
        setLoading(true)
        try {
            const res = await axios.get(`${apiUrl}/faqs/getallfaqs`);
            if (res?.data?.status === true) {
                setFaqs(res.data.faqs);
            }
        } catch (error) {
            console.log('Error fetching FAQs:', error);
            const message = error?.response?.data?.message || error.message || 'Failed to fetch enquiries'
            setError(message)
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        fetchFaqData();
    }, []);

    const toggleExpand = (id) => {
        setExpandedId(expandedId === id ? null : id);
    };

    const handleEdit = (faq) => {
        navigate('/create-edit-faqs', { state: { faq } });
    };

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${apiUrl}/faqs/deletefaq/${id}`);
            fetchFaqData();
        } catch (error) {
            console.error('Delete error:', error);
        }
    };

    return (
        <Box mt={1} sx={{ padding: { sm: 2, xs: 2, md: 4, lg: 4 } }} >
            <Typography variant="h4" mb={2} textAlign="left">
                Frequently Asked Questions
            </Typography>

            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height={200}>
                    <CircularProgress />
                </Box>
            ) : (

                faqs.length > 0 ? (
                    faqs.map((faq) => (
                        <Box key={faq.id}>
                            <Box
                                display="flex"
                                alignItems="flex-start"
                                sx={{ py: 2, cursor: 'pointer' }}
                                onClick={() => toggleExpand(faq.id)}
                            >
                                <Box mt={0.5}>
                                    {expandedId === faq.id ? <RemoveIcon color="primary" /> : <AddIcon color="primary" />}
                                </Box>
                                <Typography
                                    variant="subtitle1"
                                    fontWeight={expandedId === faq.id ? 600 : 500}
                                    ml={2}
                                    flex={1}
                                >
                                    {faq.sequenceOrder} {". "}
                                    {faq.question}
                                </Typography>
                                <Box>
                                    <Tooltip title="Edit">
                                        <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleEdit(faq); }}>
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete">
                                        <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleDelete(faq.id); }}>
                                            <DeleteIcon fontSize="small" color="error" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>
                            <Collapse in={expandedId === faq.id} timeout="auto" unmountOnExit>
                                <Typography
                                    variant="body2"
                                    sx={{ color: '#555', pl: 5, pr: 2, pb: 2 }}
                                    dangerouslySetInnerHTML={{ __html: faq.answer }}
                                />
                            </Collapse>
                            <Divider />
                        </Box>
                    ))
                ) : (
                    <Typography textAlign="center" mt={3}>
                        No FAQs found.
                    </Typography>
                )
            )}

            {error && (
                <Typography color="error" variant="body2" sx={{ mb: 2 }}>
                    {error}
                </Typography>
            )}


        </Box>
    );
};

export default DisplayFaqs;